import React, { useEffect, useState } from "react";
import {
  Input,
  SelectFund,
  SelectTab,
  ToggleInput,
} from "../../Components/FormElements";
import { PrimaryButton } from "../../Components/Cta";
import { APIService } from "../../Service";
import { toast } from "react-toastify";
import { Loader } from "../../Components/Other";

export default function ManageExploreFund() {
  const [enableExploreFunds, setEnableExploreFunds] = useState(true);
  const [numberOfFunds, setNumberOfFunds] = useState("");
  const [numberOfFundsError, setNumberOfFundsError] = useState(false);

  const [tabs, setTabs] = useState([]);
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [updatedSelectedTabs, setUpdatedSelectedTabs] = useState([]);

  const [funds, setFunds] = useState([]);
  const [selectedFunds, setSelectedFunds] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    _getExplorefundsData();
  }, []);

  useEffect(() => {
    const updatedSelectedTabs = selectedTabs.map((e) => ({
      id: e,
      label: e,
    }));

    setUpdatedSelectedTabs(updatedSelectedTabs);
  }, [selectedTabs]);

  const handleKeyPress = (e) => {
    const regex = /^[0-9]$/;

    if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
      e.preventDefault();
    }
  };

  const _getExplorefundsData = async () => {
    try {
      setLoading(true);
      const response = await APIService(false, "explore_funds/get");

      if (response.status_code === 200) {
        const data = response.data;

        setEnableExploreFunds(data.is_enabled);
        setNumberOfFunds(data.number_of_funds);

        // Categories for tabs
        const categoryTabs = data.categories.filter(
          (item) => typeof item === "object",
        );

        setTabs(categoryTabs);

        setSelectedTabs(
          categoryTabs
            .filter((item) => item.is_selected)
            .map((item) => item.value),
        );

        // Funds
        setFunds(data.funds);

        // Already selected funds
        setSelectedFunds(data.funds);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching explore funds:", error);
      setLoading(false);
    }
  };

  const filteredFunds =
    selectedTabs.length === 0
      ? funds
      : funds.filter((fund) => selectedTabs.includes(fund.asset_class));

  const handleSaveConfiguration = async () => {
    if (!enableExploreFunds) {
      const payload = {
        is_enabled: false,
        number_of_funds: 0,
        categories: [],
        fund_ids: [],
      };

      try {
        setIsSaving(true);

        const response = await APIService(true, "explore_funds/save", payload);

        if (response.status_code === 200) {
          toast.success("Configuration saved successfully.");
        } else {
          toast.error(response.message || "Something went wrong.");
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong.");
      } finally {
        setIsSaving(false);
      }

      return;
    }

    const count = Number(numberOfFunds);

    if (!count || count <= 0) {
      setNumberOfFundsError(true);
      toast.error("Please enter a valid number of funds.");
      return;
    }

    if (selectedTabs.length === 0) {
      toast.error("Please select at least one category.");
      return;
    }

    if (selectedFunds.length === 0) {
      toast.error("Please select at least one fund.");
      return;
    }

    if (selectedFunds.length < count) {
      toast.error(
        `Please select exactly ${count} fund${count > 1 ? "s" : ""}.`,
      );
      return;
    }

    const payload = {
      is_enabled: true,
      number_of_funds: count,
      categories: selectedTabs,
      fund_ids: selectedFunds.map(
        (fund) => fund.fund_id || fund.mutual_fund_id,
      ),
    };

    try {
      setIsSaving(true);

      const response = await APIService(true, "explore_funds/save", payload);

      if (response.status_code === 200) {
        toast.success("Configuration saved successfully.");
      } else {
        toast.error(response.message || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong.");
    } finally {
      setIsSaving(false);
    }
  };
  return (
    <div className="row px-3 e-pt-20px">
      {loading ? (
        <Loader width={50} />
      ) : (
        <div className="col-lg-8 col-12">
          <div className="e-border-1px-pale-lavender e-border-radius-16 e-p-24px e-bg-ghost-white-dark e-primary-font-poppins d-flex flex-column row-gap-3">
            <div className="col-md-11 col-12">
              <div className="d-flex p-3 e-bg-blue-white e-border-radius-16 column-gap-1">
                <ToggleInput
                  type={2}
                  label="Enable explore funds section"
                  checked={enableExploreFunds}
                  onChange={() => setEnableExploreFunds((prev) => !prev)}
                  labelStyle="e-primary-font-poppins e-font-14 e-font-weight-400 e-text-casual-black"
                />
              </div>
            </div>

            {enableExploreFunds ? (
              <>
                <div className="row">
                  <div className="col-12">
                    <h5 className="e-font-16 pb-0 pt-3 line-height-24px e-font-weight-600 e-text-eerie-black">
                      Display settings
                    </h5>
                  </div>

                  <div className="col-lg-5 col-md-9 col-12">
                    <Input
                      id="number-of-funds"
                      type="number"
                      label="Number of funds"
                      placeholder="Enter number of funds"
                      require={true}
                      value={numberOfFunds}
                      error={numberOfFundsError}
                      labelStyle="e-text-eerie-black e-primary-font-poppins e-font-weight-400 e-font-14 pb-2"
                      className="e-primary-font-poppins w-100"
                      onKeyPress={handleKeyPress}
                      handleChange={(e) => {
                        setNumberOfFundsError(false);
                        setNumberOfFunds(e);
                      }}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <h5 className="e-font-16 pb-0 pt-3 line-height-24px e-font-weight-600 e-text-eerie-black">
                    Display settings
                  </h5>
                  {tabs.length > 0 && (
                    <SelectTab
                      tabs={tabs}
                      curtab={selectedTabs}
                      handlechange={setSelectedTabs}
                    />
                  )}
                </div>

                {Number(numberOfFunds) > 0 && selectedTabs.length > 0 && (
                  <SelectFund
                    categories={updatedSelectedTabs}
                    funds={filteredFunds}
                    allowedSelection={Number(numberOfFunds)}
                    selectedFunds={selectedFunds}
                    onSelectionChange={setSelectedFunds}
                  />
                )}
              </>
            ) : (
              <div className="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
                <h5 className="e-font-16 pb-0 e-pt-32px line-height-24px e-font-weight-500 e-text-spanish-gray">
                  Enable Explore for fund selection
                </h5>
              </div>
            )}
          </div>

          <div className="row">
            <div className="offset-lg-7 offset-md-5 e-pt-24px col-lg-5 col-md-7 col-12">
              <PrimaryButton
                ClassName="e-border-radius-pill e-font-weight-500 py-3 w-max px-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                name="Save configuration"
                onPress={handleSaveConfiguration}
                loader={isSaving}
                disabled={isSaving}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
